import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import RadioGroupJson from "../Common/RadioGroupJson";
import parse from "html-react-parser";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

import toastr from 'toastr';

const createTaskCustomFieldExMap = {
    RadioGroupJson: (props) => <RadioGroupJson {...props} />
};

class EditRef extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            templateText:null,
            textAskDo: ''
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        console.log(`this.props.row=[${JSON.stringify(this.props.row)}]`)
        try {
            await this.props.dispatch(this.props.dataItem_Template.reset());
            await this.props.dispatch(this.props.dataItem_Template.initialize(this.props.row, {
                newItem: true,
                withParams: false
            }));

            if (!this.props.dataItem_Template.isError)
            {
                const template = this.props.dataItem_Template.getRow(0);
                this.setState({templateText: template.TemplateText, textAskDo: template.TextAskDo})

                await this.props.dispatch(this.props.dataItem_Data.reset());
                await this.props.dispatch(this.props.dataItem_Data.initialize(this.props.row, {
                    newItem: true,
                    withParams: false
                }));
            }
        } catch {
        }
    }

/*
    save = async () => {
        await this.props.dispatch(this.props.dataItem_Data.save());
        if (!this.props.dataItem_Data.isError) {
            this.props.onClose(true);
            this.showToastr("Параметры справки сохранены");
        }
    }
*/

    request = async () => {
        try {
            const text = this.state.textAskDo || i18next.t('Edit_Ref_1');
            await confirm(text);

            await this.props.dispatch(this.props.dataItem_Data.save());
            if (this.props.dataItem_Data.isError) {
                return;
            }
            await this.props.dispatch(this.props.dataItem_Request.execute(this.props.row));
            if (!this.props.dataItem_Request.isError) {
                this.props.onClose(true);
                this.showToastr(i18next.t("Edit_Ref_2"));
            }
        } catch {
        }
    }

    showToastr = (text) => {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "4000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        toastr.success(text);
    }

    renderButtons = () => {
        return (
            <div className="modal-footer text-right">
                {!this.props.readOnly &&
                    <button type="button" className="btn btn-regular -goahead" style={{"float": "left"}}
                            onClick={this.request}>{i18next.t('MakeOrder')}</button>}
                {/*{!this.props.readOnly && <button type="button" className="btn btn-regular -goahead" onClick={this.save}>Сохранить</button>}*/}
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={() => this.props.onClose(false)}>{i18next.t("Cancel_Noun")}</button>
            </div>
        );
    };

    render() {
        return (
            <>
                <PopupWrapper popupVisible={true} title={i18next.t("Edit_Ref_3")}
                              instructionId="REQUEST_EDIT"
                              onClose={this.props.onClose} renderButtons={this.renderButtons}>
                    <ComplexParam dataItem={this.props.dataItem_Data} dispatch={this.props.dispatch}
                                  renderParams={this.renderForm}
                                  autoApplyParams={false}
                                  rootPath="/"
                                  customFieldExMap={createTaskCustomFieldExMap}
                                  readOnly={this.props.readOnly}
                    />
                </PopupWrapper>
            </>
        );
    }

    renderForm = (h) => {

        if (!this.state.templateText)
            return <>{i18next.t("NoData")}</>;

        return <>{parse(this.state.templateText, {
            replace: domNode => {
                if (domNode.name === "label" && domNode.attribs && domNode.attribs.name) {
                    return this.renderLabel(h, domNode.attribs.name);
                } else if (domNode.name === "editor" && domNode.attribs && domNode.attribs.name) {
                    return <>{h.ed(domNode.attribs.name)}</>
                }

                return domNode;
            }
        })}
        </>;
    }

    renderLabel = (h, fieldName) => {

        if (fieldName == null || fieldName === "")
            return null;

        const {row, rowIndex, fi} = h;
        const fieldInfo = fi(fieldName);
        if (!fieldInfo)
            return null;

        const dataItem = this.props.dataItem_Data;

        let underlyingFi = fieldInfo;

        if (fieldInfo.Action.VirtCol) {
            const row = dataItem.getRow(rowIndex);
            underlyingFi = dataItem.getFieldInfo(row[fieldInfo.Name]);
            if (!underlyingFi) {
                underlyingFi = fieldInfo;
            }
        }

        let labelText = dataItem.getTitle(fieldInfo, rowIndex)

        if (!dataItem.getFieldIsReadOnly(fieldInfo, rowIndex) && dataItem.getFieldIsRequired(fieldInfo, rowIndex)) {

            const val = !!row ? row[underlyingFi.Name] : dataItem.getField(rowIndex, underlyingFi.Name);

            if (val == null || val === "") {
                return (<>{labelText}&nbsp;<span style={{color: "red"}}>*</span>{val}</>);
            }
        }

        return <>{labelText}</>
    }
}

EditRef.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Data: PropTypes.object,
    onClose: PropTypes.func,
    readOnly: PropTypes.bool,
    row: PropTypes.object
};

EditRef.defaultProps = {
    onClose: () => {
    },
    readOnly: false,
    row: {}
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Data: state.referencesState.EDocInfoOut_GetInfoOutData,
        dataItem_Template: state.referencesState.EDocInfoOut_GetInfoOutTempl,
        dataItem_Request: state.referencesState.EDocInfoOut_RequestPO
    }
}

export default connect(mapStateToProps)(EditRef);